<script>
import moment from 'moment';
import appointmentStatusPatient from '@/components/appointment-status/user';
import appointmentActionPatient from '@/components/appointment-action/user';
import pagination from '@/components/pagination';
export default {
    'name': 'PatientAppointmentList',
    'components': {
        appointmentStatusPatient,
        appointmentActionPatient,
        pagination
    },
    beforeRouteLeave (to, from, next) {
        this.shouldUpdate = false;
        // console.log('stopped update');
        next();
    },
    data () {
        return {
            'appointmentList': [],
            'shouldUpdate': true,
            'columnsCount': 1,
            'isTableLoading': true,
            'title': '',
            'appointmentFilterList': [],
            'pagination': {
                'currentPage': 1,
                'totalPages': 0,
                'pageSize': 20,
                'scrollPosition': 0
            }
        };
    },
    'computed': {
        currentPage () {
            return this.pagination.currentPage;
        }
    },
    'watch': {
        currentPage () {
            this.$nextTick(() => {
                this.getPatientAppointments();
            });
        }
    },
    mounted () {
        this.columnsCount = this.$refs.listTable.rows[0].cells.length;

        // initialize scroll position
        this.$nextTick(() => {
            this.pagination.scrollPosition = this.$refs.tableSection.getBoundingClientRect().top + window.scrollY - document.querySelector('.top-navigation').clientHeight;
        });

        this.getPatientAppointments();
    },
    'methods': {
        getPatientAppointments () {
            this.isTableLoading = true;
            this.axios.post('Appointment/GetPatientAppointments', {
                's': this.appointmentFilterList,
                'p': this.pagination.currentPage,
                'ps': this.pagination.pageSize
            }).then(({
                data
            }) => {
                this.isTableLoading = false;
                let pagedResult = data.data;

                this.pagination.currentPage = pagedResult.p;
                this.pagination.totalPages = pagedResult.c;

                let list = pagedResult.l;

                this.appointmentList = list.map((appointment) => ({
                    // 'fullName': user.f ? user.f : '-',
                    // 'email': user.e ? user.e : '-',
                    // 'phoneNumber': user.p ? user.p : '-',
                    // 'role': user.r === 1 ? 'User' : user.r === 99 ? 'Admin' : 'User'
                    'id': appointment.ai,
                    'date': appointment.ss ? moment(appointment.ss).format('DD/MM/YYYY') : null,
                    'time': appointment.ss ? moment(appointment.ss).format('hh:mm A') : null,
                    'doctorName': appointment.tp ? appointment.tp.fn : '-',
                    'statusId': appointment.si,
                    'status': appointment.s,
                    'consultationId': appointment.sid,
                    'consultationStatusId': appointment.dc ? appointment.dc.cs : 0
                }));

                if (this.shouldUpdate) {
                    this.loopGetAppointments = setTimeout(() => {
                        this.getPatientAppointments();
                    }, 2000);
                }
            })
                .catch(({
                    response
                }) => {

                });
        }
    }
};

</script>

<style>

</style>
